import * as zhCN from '../../../../../../config/locales/js/zh-CN.json';
angular.module('cerego.translate').constant('translateZhCN', zhCN);
